<template>
  <header>
    <div class="logo">
      <span>
        <img alt="Logo Shogi Berlin" src="../assets/images/logo2.png" />
      </span>
    </div>
    <nav id="nav-col">
      <router-link :to="getLocalUrl('/')" v-scroll-to="'#nav-col'">{{ $t('ui.nav.home') }}</router-link>
      <div class="dropdown">
        <router-link :to="getLocalUrl('/events')" v-scroll-to="'#nav-col'">
          {{ $t('ui.nav.events') }} <font-awesome-icon icon="caret-down" />
        </router-link>
        <div class="dropdown-content">
          <router-link :to="getLocalUrl('/shogi/berlintournament2019')">5.Mori Ogai (2019)</router-link>
          <router-link :to="getLocalUrl('/shogi/internalgames')">Hausliga 2019</router-link>
          <router-link :to="getLocalUrl('/shogi/berlintournament2020')">6.Mori Ogai (2020)</router-link>
          <router-link :to="getLocalUrl('/shogi/internalgames2020')">Hausliga 2020</router-link>
          <router-link :to="getLocalUrl('/shogi/berlintournament2022')">7.Mori Ogai (2022)</router-link>
          <router-link :to="getLocalUrl('/shogi/moyu2022')">1. Môyû (2022)</router-link>
          <router-link :to="getLocalUrl('/shogi/berlintournament2023')">8.Mori Ogai (2023)</router-link>
          <router-link :to="getLocalUrl('/shogi/internalgames2023')">Hausliga 2023</router-link>
          <router-link :to="getLocalUrl('/shogi/moyu2023')">2. Môyû (2023)</router-link>
        </div>
      </div>
      <div class="dropdown">
        <router-link :to="getLocalUrl('/locations')" v-scroll-to="'#nav-col'">
          {{ $t('ui.nav.locations') }} <font-awesome-icon icon="caret-down" />
        </router-link>
        <div class="dropdown-content">
          <router-link :to="getLocalUrl('/locations')" v-scroll-to="'#nav-col'">Berlin Mitte</router-link>
        </div>
      </div>
      <div class="dropdown">
        <router-link :to="getLocalUrl('/shogi/what-is-shogi')">
          {{ $t('ui.nav.shogi') }} <font-awesome-icon icon="caret-down" />
        </router-link>
        <div class="dropdown-content">
          <router-link :to="getLocalUrl('/shogi/basics')">{{ $t('ui.nav.foundations') }}</router-link>
          <router-link :to="getLocalUrl('/joseki')">{{ $t('ui.nav.joseki') }}</router-link>
          <router-link :to="getLocalUrl('/tesuji')">{{ $t('ui.nav.tesuji') }}</router-link>
          <router-link :to="getLocalUrl('/hisshi')">{{ $t('ui.nav.hisshi') }}</router-link>
          <router-link :to="getLocalUrl('/tsume')">{{ $t('ui.nav.tsume') }}</router-link>
          <router-link :to="getLocalUrl('/shogi/games')">{{ $t('ui.nav.matches') }}</router-link>
          <router-link :to="getLocalUrl('/shogi/ranking')">{{ $t('ui.nav.ranking') }}</router-link>
        </div>
      </div>
      &nbsp;<language-switcher />
    </nav>
  </header>
</template>

<script>
import LanguageSwitcher from '../shared/LanguageSwitcher.vue';

export default {
  components: { LanguageSwitcher },
  methods: {
    getLocalUrl(url) {
      const { locale } = this.$i18n;
      const localeStr = locale !== 'de' ? `/${locale}` : '';
      return `${localeStr}${url}`;
    },
  },
};
</script>

<style scoped>
header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.logo {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  height: 100%;
}

.logo > span {
  margin-left: 1.5rem;
}

.logo img {
  padding: 1rem;
  width: 15vw;
  max-width: 80px;
  height: auto;
}

header {
  background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.9) 15%,
      rgba(255, 255, 255, 0.5) 25%,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0) 100%
    ),
    url('../assets/images/hanami_cropped_900x200.jpg');
  background-position: top;
  height: 200px;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 400px) {
  .logo > span {
    margin-left: 0;
  }

  header {
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0.9) 25%,
        rgba(255, 255, 255, 0.5) 35%,
        rgba(255, 255, 255, 0) 50%,
        rgba(255, 255, 255, 0) 100%
      ),
      url('../assets/images/hanami_cropped_900x200.jpg');
  }
}

nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: #ff7f50cc;
  width: 100%;
  flex-grow: 1;
}

nav a,
nav a:visited {
  display: inline-block;
  padding: 10px;
  text-decoration: none;
  color: #ffffff;
  font-weight: bold;
  text-shadow: 1px 1px rgba(0, 0, 0, 0.3);
}

nav a:hover {
  background-color: var(--pinkish);
  color: #ffffff;
  text-decoration: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 140px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 4;
}

.dropdown-content a,
.dropdown-content a:visited {
  display: block;
  color: #090909;
  text-shadow: 0 0 transparent;
  font-weight: normal;
}

.dropdown-content a:hover {
  color: #ffffff;
  background-color: var(--pinkish);
}

.dropdown:hover .dropdown-content {
  display: block;
}

.router-link-exact-active {
  position: relative;
  color: #ffffff !important;
  background-color: var(--pinkish);
}

nav > a:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

nav > a:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
